import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const containerStyle = css({
  width: '100%',
  maxWidth: 600,
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: theme.spacing(2),
});

export const countryDropdownStyle = css`
  width: 120px;
  & > p {
    font-size: ${theme.fontSize(14)};
    padding: 0;
  }

  // hide default dropdown icon
  & > svg:last-child {
    display: none;
  }
`;
